import StickyButton from "@/common/StickyButton";
import { QuestionComponentProps } from "@/types/common";

import Review from "./Review";
import Stars from "./Stars";

const reviews = [
    {
        text: "I didn't know what to do, but now I know exactly what to do when I go to the gym. After my first Zing workout, I was hooked... it's exactly what I'm looking for!",
        name: "CocoReese",
    },
    {
        text: "I wasn't motivated to work out — so I didn't. Zing makes working out effortless. It plans workouts based on your fitness level and goals, times you, tracks everything - you just have to show up.",
        name: "Your Average Nicole",
    },
    {
        text: "Being busy makes it hard to feel motivated to get fitness in. Being able to follow these very structured and well explained workouts has definitely helped. Even a former gym rat like myself needs a little push and consistency.",
        name: "Calcaljean",
    },
];

const ReviewAndActiveUsers = ({ handleNext }: QuestionComponentProps) => (
    <div className="flex h-full flex-col justify-between text-center text-white female:text-black">
        <div>
            <div className="mb-2 text-zing-40-48 font-semibold text-zing-warm-neon-green-500 female:text-zing-warm-tangerine-500">
                Over 2 Million
            </div>
            <div>Active users worldwide</div>
            <div className="mb-6 mt-4 flex justify-center gap-4">
                <div className="flex items-center">
                    <Stars size={20} />
                    <div className="pl-1 text-zing-18-26 font-semibold">4.8</div>
                </div>
                <div className="text-zing-neutral-cool-grey-400 female:text-zing-neutral-cool-grey-600">
                    24.1K Ratings
                </div>
            </div>
            <div className="mb-6 grid gap-2">
                {reviews.map((review, i) => (
                    <Review key={i} {...review} />
                ))}
            </div>
        </div>
        <StickyButton onClick={() => handleNext()} />
    </div>
);

export default ReviewAndActiveUsers;
